import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function DishMachineIcon(props) {
	return (
		<IconBase type="dish-machine" {...props}>
			<path d="M5 3C4.72386 3 4.5 3.22386 4.5 3.5V6H19.5V3.5C19.5 3.22386 19.2761 3 19 3H5ZM13 5H11C10.4477 5 10 4.55228 10 4H14C14 4.55229 13.5523 5 13 5ZM16.5 4.5C16.5 4.77614 16.2761 5 16 5C15.7239 5 15.5 4.77614 15.5 4.5C15.5 4.22386 15.7239 4 16 4C16.2761 4 16.5 4.22386 16.5 4.5ZM18 5C17.7239 5 17.5 4.77614 17.5 4.5C17.5 4.22386 17.7239 4 18 4C18.2761 4 18.5 4.22386 18.5 4.5C18.5 4.77614 18.2761 5 18 5Z" />
			<path d="M5 3C4.72386 3 4.5 3.22386 4.5 3.5V6H19.5V3.5C19.5 3.22386 19.2761 3 19 3H5ZM13 5H11C10.4477 5 10 4.55228 10 4H14C14 4.55229 13.5523 5 13 5ZM16.5 4.5C16.5 4.77614 16.2761 5 16 5C15.7239 5 15.5 4.77614 15.5 4.5C15.5 4.22386 15.7239 4 16 4C16.2761 4 16.5 4.22386 16.5 4.5ZM18 5C17.7239 5 17.5 4.77614 17.5 4.5C17.5 4.22386 17.7239 4 18 4C18.2761 4 18.5 4.22386 18.5 4.5C18.5 4.77614 18.2761 5 18 5Z" />
			<path d="M19 21H5V19H19V21Z" />
			<path d="M19 21H5V19H19V21Z" />
			<path d="M19 18C19.2761 18 19.5 17.7761 19.5 17.5V7H4.5V17.5C4.5 17.7761 4.72386 18 5 18H19Z" />
			<path d="M19 18C19.2761 18 19.5 17.7761 19.5 17.5V7H4.5V17.5C4.5 17.7761 4.72386 18 5 18H19Z" />
		</IconBase>
	);
}
DishMachineIcon.propTypes = iconPropTypes;
